import {toast,Slide} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const errorToast=(message)=>{
    toast(message ,{
        style:{
        maxWidth:"500px",
        minWidth:"300px",
        height: "80px !important",
        direction:"rtl",
        borderRight:"1.2rem solid red",
        borderTopRightRadius:"1rem",
        borderBottomRightRadius:"1rem",
        margin:"3rem auto 0"
    },
    transition:Slide,
    autoClose:false,
    draggable: true,
    progress: undefined,
    hideProgressBar: true,
    closeOnClick: true,
    position: "top-center",} )
}
export const succToast=(message)=>{
    toast(message ,{
        style:{
        maxWidth:"500px",
        minWidth:"300px",
        height: "80px !important",
        direction:"rtl",
        borderRight:"1.2rem solid green",
        borderTopRightRadius:"1rem",
        borderBottomRightRadius:"1rem",
        margin:"3rem auto 0"
    },
    transition:Slide,
    autoClose:true,
    draggable: true,
    progress: undefined,
    hideProgressBar: true,
    closeOnClick: true,
    position: "top-center",} )
}